<template>
  <div class="content-430">
    <div class="class-form-head">基础信息</div>
    <div class="class-form-content">
      <Form
        ref="baseInfo"
        :model="baseInfo"
        label-position="right"
        :label-width="150"
        :rules="baseInfoRule"
        @on-validate="getFormValidate"
      >
        <FormItem
          label="教师课酬方案名称"
          prop="planName"
        >
          <Input
            v-if="!isSet"
            v-model="baseInfo.planName"
            class="class-form-item"
            placeholder="请输入"
            @on-blur="handleTrimValue('planName')"
          ></Input>
          <span v-else>{{ baseInfo.planName }}</span>
        </FormItem>
        <FormItem
          label="适用学期"
          prop="termSelect"
        >
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :default-year-terms="yearTerms"
            :need-init-data="isCopy?false:true"
            :placeholder="`请选择年度学期`"
            :clearable="false"
            :disabled-year-term="planId!==''&&!isCopy"
            class="class-form-item"
            @on-change="onCascaderChange"
          ></CascaderYearTerms>
        </FormItem>
        <FormItem
          label="基础设置"
          prop="isCalLeave"
        >
          <Checkbox v-model="baseInfo.isCalLeave" :disabled="isSet">请假计入课酬（勾选后学生请假的考勤将参与教师工资梯度计算）</Checkbox>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
export default {
  components: {
    CascaderYearTerms
  },
  inject: ['SalarySettingEditInstance'],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          planName: '', // 教师课酬方案名称
          termSelect: '',
          yearCode: '',
          termCode: '',
          isCalLeave: false
        };
      }
    }, // v-model的值
    isCopy: {
      type: Boolean,
      default: false
    }, // 是否是复制
    isSet: {
      type: Boolean,
      default: false
    } // 设置适用学校
  },
  data() {
    // 课程价格规则
    const validatePlanName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入教师课酬方案名称'));
      } else if (value.length > 30) {
        callback(new Error('教师课酬方案名称限制30个字'));
      } else {
        callback();
      }
    };
    return {
      baseInfoRule: {
        planName: [
          { required: true, validator: validatePlanName, trigger: 'blur' }
        ],
        termSelect: [{ required: true, message: '请选择年度学期', trigger: 'change' }],
        isCalLeave: [{ type: 'boolean', message: '请选择设置', trigger: 'change' }]
      },
      baseInfoRequired: {},
      planId: '',
      yearTerms: []
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity']),
    baseInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  created() {
    this.planId = this.$route.query.planId ? this.$route.query.planId : '';
    this.dealFormRequire();
  },
  mounted() {
    this.SalarySettingEditInstance.findRuleRequire(
      this,
      'baseInfo',
      '基础信息'
    );
  },
  methods: {
    // 校验表单
    checkForm() {
      this.$refs.baseInfo.validate();
    },
    fillTerm() {
      this.yearTerms = [+this.baseInfo.yearCode, this.baseInfo.termCode + ''];
      this.$refs.cascaderYearTerms.yearTerms = this.yearTerms;
      console.log('赋值----');
    },
    dealFormRequire() {
      Object.keys(this.baseInfoRule).forEach((item) => {
        this.baseInfoRequired[item] = {
          require: !!this.baseInfoRule[item][0].required,
          status: false
        };
      });
    },
    handleTrimValue(keyName) {
      if (!keyName) {
        return null;
      }
      this.baseInfo[keyName] = this.baseInfo[keyName].trim();
    },
    getFormValidate(prop, status, error) {
      this.baseInfoRequired[prop].status = status;
      this.SalarySettingEditInstance.findRuleRequire(
        this,
        'baseInfo',
        '基础信息'
      );
    },
    onCascaderChange(v) {
      if (v) {
        console.log(v, '年度资源学期');
        this.baseInfo.yearCode = v[0];
        this.baseInfo.termCode = v[1];
        this.baseInfo.termSelect = 'true';
      } else {
        this.baseInfo.yearCode = '';
        this.baseInfo.termCode = '';
        this.baseInfo.termSelect = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
